import { template as template_d83a67c04d274c3b89d6638e1b5bd32c } from "@ember/template-compiler";
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import RouteTemplate from 'ember-route-template';
import { Model } from '../../routes/render/icon';
export default RouteTemplate(template_d83a67c04d274c3b89d6638e1b5bd32c(`
  <@model.Component />
`, {
    eval () {
        return eval(arguments[0]);
    }
}) satisfies TemplateOnlyComponent<{
    Args: {
        model: Model;
    };
}>);
